import e from "./_freeGlobal.js";
var r = e, o = typeof self == "object" && self && self.Object === Object && self, t = r || o || Function("return this")(), l = t;
export {
  l as default
};
//# sourceMappingURL=_root.js.map
